module.exports = __webpack_public_path__ + "img/128.e55c49d4.jpg";